import React, {useContext} from 'react';
import Message from '../../components/message/Message';
import {Link} from 'react-router-dom';
import {generateRoutePath} from 'epic-ue-locale-mode';
import {HttpContext} from '../../../server/utils/httpContext';

/**
 * 404 component.  Shown when page not found.
 */
const Error404 = function Error404() {
    const context = useContext(HttpContext);
    if (context) {
        context.status = 404;
    }

    return (
        <div id="errorpage">
            <div className="error-box">
                <div>
                    <h1>404</h1>
                    <h2>
                        <Message code="epic.error.404.title1" />
                        <Message code="epic.error.404.title2" />
                    </h2>
                    <p>
                        <Message code="epic.error.404.msg" />
                    </p>
                    <Link to={generateRoutePath('/')} className="cta-button text-center">
                        <Message code="epic.error.404.home" />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Error404;
